import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-rpx-components-ui',
  template: `
    <p>
      rpx-components-ui works!
    </p>
  `,
  styles: []
})
export class RpxComponentsUiComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
